// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c8dcr7{font:var(--ds-font-body-UNSAFE_small,normal 400 9pt/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._1e0c1o8l{display:inline-block}\n._1pfhze3t{margin-block-start:var(--ds-space-0,0)}\n._6rth1b66{margin-block-end:var(--ds-space-050,4px)}\n._k48pmoej{font-weight:var(--ds-font-weight-bold,700)}\n._syaz1gjq{color:var(--ds-text-subtle,#44546f)}", ""]);
// Exports
module.exports = exports;
